const config = {
  IMAGE_VERSION: "1.5.7", // Automatically updated by the CI/CD pipeline
  GIT_REVISION: "0997283", // Automatically updated by the CI/CD pipeline

  SLACK_URL: "https://bamboohr.slack.com/archives/C0549BSKHQT",
  REQUEST_FORM_URL: "https://forms.gle/zjkthNu2nnBWy7yT8",
  INTERNAL_POLICY_URL: "https://bamboohr.slite.com/app/docs/2zXZ_z4xuEjpdT",
  EXTERNAL_POLICY_URL:
    "https://www.bamboohr.com/legal/bamboohr-artificial-intelligence-addendum",
  VERSION_ENDPOINT: "v0/",
  REQUEST_ID_HEADER: "BHR-Request-ID",
  USER_PROPERTIES: ["_id", "has-accepted-terms", "metadata"],
  DEFAULT_LLM_CONFIG: {
    opts: {
      model: "gpt-4o",
    },
  },
  DEFAULT_FUNCTION_LABEL: "OpenAI: GPT 4o",
  DEFAULT_FUNCTION_ID: "query-openai-llm",
  QUERY_OPENAI_LLM_FUNCTION_ID: "query-openai-llm",
  QUERY_ANTHROPIC_LLM_FUNCTION_ID: "query-anthropic-llm",
  QUERY_GOOGLE_LLM_FUNCTION_ID: "query-google-llm",
  QUERY_COHERE_LLM_FUNCTION_ID: "query-cohere-llm",
  ROLLBAR_ACCESS_TOKEN: "15f6ca70b3104801bc412277cc0957a5",
  // Keyed by the function id /v0/modes advertises.
  SUPPLEMENTS: {
    "cx-assistant-command-of-message": {
      title: "Value Add Opportunity:",
      errorText: "Value-add recommendations couldn't be loaded for this answer.",
    },
  },
  DEFAULT_SUPPLEMENT: {
    title: "Additional context:",
    errorText: "This section couldn't be loaded for this answer.",
  },
  // Mirrors the server's cap on a stored supplemental observation. Over it, the
  // PUT is rejected and the result is lost, so the text is truncated to fit.
  SUPPLEMENT_OBSERVATION_MAX_LENGTH: 10000,
  // What PUT v0/chat/:id returns when a supplemental result is appended. Any
  // other response means it did not land, and is reported rather than retried.
  SUPPLEMENT_UPDATE_SUCCESS_MESSAGE: "success",
  DEVELOPMENT: process.env.REACT_APP_BHR_ENV === "development",
  AUTH_POLLING_INTERVAL: 60000, // 1 minute
};

export default config;
